import { render } from "./ReinitiatePassword.vue?vue&type=template&id=151fd507"
import script from "./ReinitiatePassword.vue?vue&type=script&lang=js"
export * from "./ReinitiatePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__